import { getTime } from 'date-fns';

/**
 * Convert and retrieve dates from DD/MM/YYYY pattern.
 * @param {string} dateString
 * @returns {Date} converted date
 */
function getDateConverted(dateString: string) {
  const d = new Date();
  const dateArray = dateString.split('/');
  d.setFullYear(
    parseInt(dateArray[2], 10),
    parseInt(dateArray[1], 10) - 1,
    parseInt(dateArray[0], 10),
  );
  return d;
}

/**
 * Convert dates from YYYY-MM-DD to DD/MM/YYYY
 * @param {string} dateString
 * @returns {Date} converted date
 */
function getDateSplit(dateString: string) {
  const dateArray = dateString.split('-');
  return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
}

const datetime = new Date().getTime();

const oneWeekAgo = {
  oneDayAgo: datetime - 1000 * 60 * 60 * 24 * 1,
  startDate: datetime - 1000 * 60 * 60 * 24 * 7,
  endDate: datetime,
};

const oneMonthAgo = {
  startDate: datetime - 1000 * 60 * 60 * 24 * 30,
  endDate: datetime,
};

export function howManyDaysAgo(day: number) {
  const datetime = new Date().setHours(0, 0, 0);
  return datetime - 1000 * 60 * 60 * 24 * day;
}

/**
 * Convert dates from YYYY-MM-DD to DD/MM/YYYY pattern.
 * @param {string} dateString
 * @returns {string} converted date
 */
function formatDate(dateString: string) {
  if (dateString) {
    const dateArray = dateString.split('-');

    const date = {
      dd: dateArray[2],
      mm: dateArray[1],
      yyyy: dateArray[0],
    };

    const { dd, mm, yyyy } = date;

    return `${dd}/${mm}/${yyyy}`;
  }
  return dateString;
}

/**
 * Convert dates from '1970-01-01T22:50:00.000Z' to DD/MM/YYYY using new Date()
 */

function formatDateString(dateString: string) {
  if (dateString) {
    const dd = new Date(dateString).getDate();
    const mm = new Date(dateString).getMonth();
    const yyyy = new Date(dateString).getFullYear();
    return `${dd < 10 ? 0 : ''}${dd}/${mm + 1 < 10 ? 0 : ''}${mm + 1}/${yyyy}`;
  }
  return '---';
}

/**
 * Convert dates from '1970-01-01T22:50:00.000Z' to DD/MM/YYYY
 */

const dateFromToIoSoDate = (date: string) => {
  if (date) {
    const [year, month, day] = date.split('T')?.[0]?.split('-');
    return `${day}/${month}/${year}`;
  }
  return date;
};

const valuesFromToIoSoDate = (date?: string) => {
  if (date) {
    const [year, month, day] = date.split('T')?.[0]?.split('-');
    return { day: Number(day), month: Number(month), year: Number(year) };
  }
  return { day: 0, month: 0, year: 0 };
};

/**
 * Parse dates from '16072024' to DD/MM/YYYY
 */
const clearDate = (date: string) => {
  if (date) {
    const cleanedDate = date.replaceAll('/', '');
    const day = cleanedDate.substring(0, 2);
    const month = cleanedDate.substring(2, 4);
    const year = cleanedDate.substring(4, 8);
    return `${day}/${month}/${year}`;
  }
  return date;
};

/**
 * Get hour and minutes from '1970-01-01T22:50:00.000Z'
 */

const formatTime = (time: number): string => `${time < 10 ? '0' : ''}${time}`;

const getHoursFromToIoSoDate = (date: string) => {
  if (date) {
    const [hour, _] = date.split('T')?.[1]?.split(':');
    return formatTime(Number(hour));
  }
  return date;
};

const getMinutesFromToIoSoDate = (date: string) => {
  if (date) {
    const [_, minute] = date.split('T')?.[1]?.split(':');
    return formatTime(Number(minute));
  }
  return date;
};

const formatDateAndTime = (date: any) => {
  const day = date
    .getDate()
    .toString()
    .padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  const hours = date
    .getHours()
    .toString()
    .padStart(2, '0');
  const minutes = date
    .getMinutes()
    .toString()
    .padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

function returnDate(date: any) {
  const fullDate = new Date(date).toLocaleDateString('pt-BR');
  const minutes = new Date(date).getMinutes();

  return `${fullDate}`;
}

function returnDateAndTime(date: any) {
  const fullDate = new Date(date).toLocaleDateString('pt-BR');
  const hours = new Date(date).getHours();
  const minutes = new Date(date).getMinutes();

  return `${fullDate} • ${hours < 10 ? 0 : ''}${hours}:${
    minutes < 10 ? 0 : ''
  }${minutes}`;
}

function prettieDateAndTime(date: any) {
  const fullDate = new Date(date).toLocaleDateString('pt-BR');
  const hours = new Date(date).getHours();
  const minutes = new Date(date).getMinutes();

  return `${fullDate} às ${hours < 10 ? 0 : ''}${hours}:${
    minutes < 10 ? 0 : ''
  }${minutes}`;
}

function getHours(date: any) {
  const hours = new Date(date).getHours();
  const minutes = new Date(date).getMinutes();

  return `${hours < 10 ? 0 : ''}${hours}:${minutes < 10 ? 0 : ''}${minutes}`;
}

/**
 * Checke if both dates is equal
 * @param dateLeft
 * @param dateRight
 * @returns
 */
function isEqual(dateLeft: Date, dateRight: Date) {
  return (
    dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getDate() === dateRight.getDate() &&
    dateLeft.getMonth() === dateRight.getMonth()
  );
}

export function dateToTimestamp(
  date: string,
  hours?: number,
  minutes?: number,
  seconds?: number,
) {
  const sliced = date?.split('-');
  return getTime(
    new Date(
      Math.abs(+sliced[0]),
      Math.abs(+sliced[1]) - 1,
      Math.abs(+sliced[2]),
      hours || 0,
      minutes || 0,
      seconds || 0,
    ),
  );
}

export function dateToTimestampV2(
  date: string,
  hours?: number,
  minutes?: number,
  seconds?: number,
) {
  const sliced = date?.split('-');
  return Date.UTC(
    Math.abs(+sliced[0]),
    Math.abs(+sliced[1]) - 1, // Month is zero-indexed in Date
    Math.abs(+sliced[2]),
    hours || 0,
    minutes || 0,
    seconds || 0,
  );
}

export function extractHoursOnDateString(date: string, fullHours?: boolean) {
  if (!date || !date.includes('T') || !date.endsWith('Z')) return date;

  const [hour, minute, second] = date.split('T')?.[1]?.split(':');

  return fullHours
    ? `${hour}:${minute}:${second.split('.')?.[0]}`
    : `${hour}:${minute}`;
}
export function verifyHourAndMinutes(value: string) {
  const time = value.split(':');

  let hours1 = '';
  let minutes1 = '';
  let hours2 = '';
  let minutes2 = '';

  if (value) {
    if (/^[0-2]$/.test(time[0][0])) hours1 = time[0][0];
    if (/^[0-9]$/.test(time[0][1])) hours2 = time[0][1];
    if (/^[0-5]$/.test(time[1][0])) minutes1 = time[1][0];
    if (/^[0-9]$/.test(time[1][1])) minutes2 = time[1][1];

    return `${hours1}${hours2}:${minutes1}${minutes2}`;
  }
  return null;
}

/**
 * Convert dates from '1970-01-01T22:50:00.000Z' to DD/MM/YYYY às 00:00
 */

function formatDateStringToAs(dateString: string) {
  if (dateString) {
    return `${formatDateString(dateString)} às ${getHoursFromToIoSoDate(
      dateString,
    )}:${getMinutesFromToIoSoDate(dateString)}`;
  }
  return '---';
}

function getHourAndMinute(dateString: string) {
  if (dateString) {
    return `${getHoursFromToIoSoDate(dateString)}:${getMinutesFromToIoSoDate(
      dateString,
    )}`;
  }
  return '---';
}

function parseTimeStringToTimeLacal(timeString: string) {
  const today = new Date();
  const date = new Date(
    `${today.getFullYear()}-${today.getMonth()}-${today.getDate()} ${timeString} +0000`,
  );
  return date.toLocaleString('pt-BR', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

const isDate = (date: string) => {
  const isValid = new RegExp(
    '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$',
  );

  return isValid.test(date);
};

const calculateDateFromAge = (age: number): Date => {
  const today = new Date();
  return new Date(today.getFullYear() - age, today.getMonth(), today.getDate());
};

const isDateWithinRange = (date?: number, minDate?: number, maxDate?: number) => {
  if (!date) return false;
  if (maxDate && date! < calculateDateFromAge(maxDate).getTime()) return false;
  if (minDate && date! > calculateDateFromAge(minDate).getTime()) return false;
  return true;
};

export {
  getDateConverted,
  formatDateAndTime,
  datetime,
  oneWeekAgo,
  oneMonthAgo,
  formatDate,
  isEqual,
  returnDate,
  returnDateAndTime,
  prettieDateAndTime,
  getDateSplit,
  getHours,
  formatDateString,
  formatDateStringToAs,
  getHoursFromToIoSoDate,
  getMinutesFromToIoSoDate,
  parseTimeStringToTimeLacal,
  isDate,
  dateFromToIoSoDate,
  clearDate,
  valuesFromToIoSoDate,
  getHourAndMinute,
  calculateDateFromAge,
  isDateWithinRange,
};
